import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';
import { getScratchpad } from '../../api/clients/scratchpad';

const initialState = {
  title: '',
  viewInScratchpad: {},
  data: [],
  loading: false
};

const prefix = actionPrefix('scratchpad');

// Actions
const FETCH_REQUEST = prefix('FETCH_REQUEST');
const FETCH_ERROR = prefix('FETCH_ERROR');
const FETCH_SUCCESS = prefix('FETCH_SUCCESS');

// Reducers
export default createReducer(initialState, {
  [FETCH_REQUEST](state) {
    return {
      ...state,
      loading: true
    };
  },
  [FETCH_ERROR](state, { payload }) {
    return {
      ...state,
      loading: false,
      error: payload
    };
  },
  [FETCH_SUCCESS](state, { payload }) {
    return {
      ...state,
      ...payload,
      loading: false
    };
  }
});

// Action creators
export const request = () => ({
  type: FETCH_REQUEST
});

export const error = message => ({
  type: FETCH_ERROR,
  payload: message
});

export const success = scratchpad => ({
  type: FETCH_SUCCESS,
  payload: scratchpad
});

// Effects
export const fetchScratchpad = () => (dispatch, getState) => {
  dispatch(request());

  const { siteName, environment } = getState().system;
  const { locale } = getState().intl;
  const { publicUuid, havId } = getState().user;

  if (havId || publicUuid) {
    try {
      getScratchpad({ siteName, locale, publicUuid, havId, environment }).then(data => dispatch(success(data)));
    } catch ({ message }) {
      dispatch(error(message));
    }
  }
};



// WEBPACK FOOTER //
// ./src/universal/redux/modules/scratchpad.js